"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.restructureInsightsPayload = exports.getUserCreator = void 0;
const getUserCreator = (user) => {
    return {
        id: user?.id,
        externalId: user?.externalId,
        email: user?.email,
        name: user?.name,
        role: user?.role,
        cultureRole: user?.cultureRole,
        state: user?.state,
        profilePicture: user?.profilePicture,
        workloadStatus: user?.workloadStatus
    };
};
exports.getUserCreator = getUserCreator;
const restructureInsightsPayload = (insights, columns) => {
    const dataInsight = [];
    const sectionData = insights.map(({ sectionData }) => sectionData);
    for (let i = 0; i < sectionData.length; i++) {
        sectionData[i].map((row) => {
            dataInsight.push({
                rowNumber: row?.rowNumber,
                rowName: row?.rowName,
                columnNumber: columns?.[i]?.order,
                columnName: columns?.[i]?.name,
                columnType: columns?.[i]?.type,
                objectiveId: row.objective?.id || null
            });
        });
    }
    return dataInsight;
};
exports.restructureInsightsPayload = restructureInsightsPayload;
